import { Spinner } from '@ui/lib/park/ui/spinner';
import { Text } from '@ui/lib/park/ui/text';
import { Center, Grid, Stack } from 'styled-system/jsx';

import { CompetitionCard } from './CompetitionCard';
import { Competition, CompetitionStatus } from './types';

interface CompetitionListProps {
  competitions: Competition[];
  isLoading?: boolean;
  onSelect?: (competition: Competition) => void;
  onJoin?: (competition: Competition) => void;
  isConnected?: boolean;
}

export const CompetitionList = ({
  competitions,
  isLoading,
  onSelect,
  onJoin,
  isConnected,
}: CompetitionListProps) => {
  if (isLoading || !competitions) {
    return (
      <Center py={20}>
        <Spinner w="12" h="12" />
      </Center>
    );
  }

  if (competitions.length === 0) {
    return (
      <Stack align="center" py={20}>
        <Text textStyle="text.small" color="v2.text.subtle">
          No competitions found.
        </Text>
      </Stack>
    );
  }

  // Ongoing events render as full-width featured cards; upcoming/ended as a 2-col grid.
  const featured = competitions.filter(
    (c) => c.status === CompetitionStatus.ONGOING,
  );
  const rest = competitions.filter(
    (c) => c.status !== CompetitionStatus.ONGOING,
  );

  return (
    <Stack gap={{ base: '12px', tablet: '16px' }}>
      {featured.map((comp) => (
        <CompetitionCard
          key={comp.id}
          competition={comp}
          onSelect={onSelect}
          onJoin={onJoin}
          isConnected={isConnected}
        />
      ))}

      {rest.length > 0 && (
        <Grid
          gridTemplateColumns={{
            base: '1fr',
            desktop: 'repeat(2, minmax(0, 1fr))',
          }}
          gap="8px"
        >
          {rest.map((comp) => (
            <CompetitionCard
              key={comp.id}
              competition={comp}
              onSelect={onSelect}
              onJoin={onJoin}
              isConnected={isConnected}
            />
          ))}
        </Grid>
      )}
    </Stack>
  );
};
